"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogSinkError = exports.TestAssertUnexpectedLogError = exports.LogSink = exports.LogLevels = void 0;
exports.LogLevels = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
};
/**
 * The interface that all LogSinks need to implement
 */
class LogSink {
    constructor(limit) {
        this.minimumLevel = "minimumLevel" in limit ? limit.minimumLevel : null;
        this.maximumLevel = "maximumLevel" in limit ? limit.maximumLevel : null;
    }
    shouldHandleLogEntry(logEntry) {
        const level = exports.LogLevels[logEntry.level];
        const numericLevel = Object.values(exports.LogLevels);
        const min = this.minimumLevel
            ? exports.LogLevels[this.minimumLevel]
            : numericLevel[0];
        const max = this.maximumLevel
            ? exports.LogLevels[this.maximumLevel]
            : numericLevel[numericLevel.length - 1];
        return level >= min && level <= max;
    }
}
exports.LogSink = LogSink;
// Errors
class TestAssertUnexpectedLogError extends Error {
    constructor(message) {
        super(message);
        this.name = "TestAssertUnexpectedLogError";
        this.type = "TestAssertUnexpectedLogError";
    }
}
exports.TestAssertUnexpectedLogError = TestAssertUnexpectedLogError;
class LogSinkError extends Error {
    constructor(message) {
        super(message);
        this.name = "LogSinkError";
        this.type = "LogSinkError";
    }
}
exports.LogSinkError = LogSinkError;
//# sourceMappingURL=types.js.map